import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsOwnFuelStations = {
  CREATE: '/v1/fuelStations/own',
  LOAD: (filter, sort, limit, skip) =>
    `/v1/fuelStations/own${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_ID: (id) => `/v1/fuelStations/own/${id}`,
}

export default endpointsOwnFuelStations
